import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import type {User} from 'nutshell-core/users/users-types';

import {CardWidgetWrapper} from '../../../core/card';
import {getCustomFieldAddOptions} from '../../../core-entity/util/widget-components';

import {ClientRouteLegacyLinks} from '../../../../client-route-legacy-links';

type Props = {
    stagesetId: string | null | undefined;
    sidebarCustomFields: HTMLElement | null | undefined;
    sidebarCustomFieldsCount: number;
    onRenderLeadMarkup: () => void;
    history: RouterHistory;
    user: User | null | undefined;
};

export function CustomFieldsWidgetOld(props: Props) {
    const isEmpty = props.sidebarCustomFieldsCount === 0;

    return (
        <CardWidgetWrapper
            widgetKey='leadCustomFields'
            count={props.sidebarCustomFieldsCount}
            isLoading={!props.sidebarCustomFields}
            isEmpty={isEmpty}
            // @ts-expect-error
            addButtonProps={getCustomFieldAddOptions(props.user, props.stagesetId)}
            rowsHavePadding={false}
        >
            {props.sidebarCustomFields && (
                <ClientRouteLegacyLinks history={props.history}>
                    {({interceptClicks}) => (
                        <div
                            onClick={interceptClicks}
                            ref={(ref) => {
                                if (ref && props.onRenderLeadMarkup) {
                                    props.onRenderLeadMarkup();
                                }
                            }}
                            dangerouslySetInnerHTML={{
                                // @ts-expect-error
                                __html:
                                    props.sidebarCustomFields &&
                                    props.sidebarCustomFields.outerHTML,
                            }}
                        />
                    )}
                </ClientRouteLegacyLinks>
            )}
        </CardWidgetWrapper>
    );
}
